export const AuthController = {
    showLoginForm(): void {},
    login(): void {},
    showRegisterForm(): void {},
    register(): void {},
    verifySignupCode(): void {},
    showForgotEmailForm(): void {},
    handleForgotEmail(): void {},
    showForgotPasswordForm(): void {},
    forgotPassword(): void {},
    showResetPasswordFormWithToken(): void {},
    showResetPasswordForm(): void {},
    handleResetPassword(): void {},
    showProfileForm(): void {},
    updateProfile(): void {},
    showChangePasswordForm(): void {},
    changePassword(): void {},
    showChangeEmailForm(): void {},
    sendChangeEmailCode(): void {},
    confirmChangeEmail(): void {},
    deleteAccount(): void {},
};
